import { Box } from "@mui/material";
import React from "react";
import toast from "react-hot-toast";
import { Modal } from "../../../components";

interface PreviewImageProps {
  open: boolean;
  onClose: () => void;
  imageUrl: string;
  title: string;
}

const PreviewImage: React.FC<PreviewImageProps> = ({
  open,
  onClose,
  imageUrl,
  title,
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      showClose={true}
      title={title}
      modalContainerStyle={{
        maxWidth: "95vw",
        maxHeight: "95vh",
        width: "auto",
        height: "auto",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "50vh",
          maxHeight: "85vh",
          overflow: "hidden",
          p: 2,
        }}
      >
        <img
          src={imageUrl}
          alt={title}
          style={{
            maxWidth: "100%",
            maxHeight: "85vh",
            width: "auto",
            height: "auto",
            objectFit: "contain",
            borderRadius: "12px",
            boxShadow: "0 12px 40px rgba(0,0,0,0.3)",
            background: "#fff",
          }}
          onError={() => toast.error("Failed to load image")}
          onLoad={(e) => {
            (e.target as HTMLImageElement).scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
          }}
        />
      </Box>
    </Modal>
  );
};

export default PreviewImage;
